import BadgerAccordion from 'badger-accordion';

let accordion = null;

// Creating a new instance of the accordion
const accordionDomNode = document.querySelector('.js-badger-accordion');

if(accordionDomNode){
    accordion = new BadgerAccordion(accordionDomNode);
}

const accordionButtons = document.querySelectorAll('.js-badger-accordion-header')

if (accordionButtons && accordion) {
    accordionButtons.forEach(button => {
        button.addEventListener('click', e => {
            accordion.calculateAllPanelsHeight()
        })
    })
}
